import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightbulb = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 56,
	height: 76,
	viewBox: "0 0 56 76",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16.9998 61.9998H38.9998V67.9998C38.9998 72.4178 35.4178 75.9998 30.9998 75.9998H24.9998C20.5818 75.9998 16.9998 72.4188 16.9998 67.9998C16.9998 66.0498 16.9998 63.9608 16.9998 61.9998ZM26.1938 0.0567995C12.3408 0.9258 1.04082 12.1368 0.0708162 25.9828C-0.692184 36.8718 4.77682 46.5488 13.2688 51.8128C15.4398 53.1588 16.7858 55.4728 16.9638 57.9998H39.0348C39.2118 55.4998 40.5118 53.1788 42.6608 51.8568C50.6638 46.9288 55.9998 38.0878 55.9998 27.9998C55.9998 11.9378 42.4758 -0.9652 26.1938 0.0567995Z" })
});
export default SvgLightbulb;
